<div class="modifier-color-wrapper" *ngIf="editMode || colorConfig?.color"
     [class.view-mode]="!editMode"
     [class.has-color]="colorConfig?.color">
  <div class="modifier-color-tag"
       [style.background-color]="colorConfig?.color ? colorConfig.color + '33' : 'transparent'">
    <div *ngIf="colorConfig?.color"
         class="color-circle"
         [style.background-color]="colorConfig.color">
    </div>
    <span class="label" [style.color]="colorConfig?.color">{{ colorConfig?.label ||
      'NONE' }}</span>
  </div>
  <ion-icon *ngIf="showCheckmark && editMode"
            name="checkmark"
            class="checkmark">
  </ion-icon>
</div>